<template>
  <div style="background: #f5f7f9">
    <pcHeaders></pcHeaders>
      <div>
    <!-- 引入对话组件 -->
    <!-- <doubao
      ref="chatRef"
      :knowledge-base-id="knowledgeBaseId"
      welcome-text="你好！我是课程助手，有任何课程相关问题都可以问我～"
      input-placeholder="请输入课程相关问题...（回车发送）"
      :temperature="0.5"
      @message-success="handleMessageSuccess"
      @message-error="handleMessageError"
    /> -->

      </div>
    <div class="nav">
      <el-carousel indicator-position="outside" :interval="3000" loop trigger="click">
        <el-carousel-item v-for="item in lunboPicList" :key="item.id">
          <img :src="item.picUrl" alt="" style="cursor: pointer" @click="swipeDetail(item)" />
        </el-carousel-item>
      </el-carousel>
      <div class="flowBox">
        <div class="group_1">
          <div class="flow_1">
            <img src="../assets/images/Group 1575@2x.png" alt="" />
            <div class="flow_2">
              <div>第一步</div>
              <div>学员注册登录</div>
            </div>
          </div>
          <div class="jiantou"><img src="../assets/images/Group 1574@2x.png" alt="" /></div>
          <div class="flow_1">
            <img src="../assets/images/Group 1577@2x.png" alt="" />
            <div class="flow_2">
              <div>第二步</div>
              <div>填写个人资料</div>
            </div>
          </div>
          <div class="jiantou"><img src="../assets/images/Group 1574@2x.png" alt="" /></div>
          <div class="flow_1">
            <img src="../assets/images/Group 1578@2x.png" alt="" />
            <div class="flow_2">
              <div>第三步</div>
              <div>选择购买课程</div>
            </div>
          </div>
          <div class="jiantou"><img src="../assets/images/Group 1574@2x.png" alt="" /></div>
          <div class="flow_1">
            <img src="../assets/images/Group 1579@2x.png" alt="" />
            <div class="flow_2">
              <div>第四步</div>
              <div>完成线上线下学习</div>
            </div>
          </div>
          <div class="jiantou"><img src="../assets/images/Group 1574@2x.png" alt="" /></div>
          <div class="flow_1">
            <img src="../assets/images/Group 1581@2x.png" alt="" />
            <div class="flow_2">
              <div>第五步</div>
              <div>通过官方考试</div>
            </div>
          </div>
          <div class="jiantou"><img src="../assets/images/Group 1574@2x.png" alt="" /></div>
          <div class="flow_1">
            <img src="../assets/images/Group 1580@2x.png" alt="" />
            <div class="flow_2">
              <div>第六步</div>
              <div>获取证书</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      style="display: flex; flex-direction: column; justify-content: center; align-items: center; background-color: #fff; padding-top: 8px"
    >
      <!-- 快捷通道 -->
      <div class="group_2">
        <div class="kjBox" @click="handleCode1('0701')">
          <div class="text_1">特种作业</div>
          <div class="text_2">提供全流程、专业化的培训服务，助力学员快速拿证、安全上岗</div>
        </div>
        <div class="kjBox_1" @click="handleCode1('0702')">
          <div class="text_1">高危行业</div>
          <div class="text_2">降低事故发生风险，保障员工生命安全和企业生产经营的顺利进行</div>
        </div>
        <div class="kjBox_2" @click="handleCode1('0703')">
          <div class="text_1">非高危行业</div>
          <div class="text_2">助力企业落实安全生产主体责任，提升员工安全素养，防范常见安全事故</div>
        </div>
        <div class="kjBox_3" @click="handleCode1()">
          <div class="text_1">全部课程</div>
          <div class="text_2">专注应急安全培训，提供从理论到实操的全链条课程服务</div>
        </div>
      </div>
      <!-- 新闻通知 -->
      <div class="group_3">
        <div class="note_left">
          <div class="note_title">
            <span class="title_1">培训通知</span
            ><span class="title_2" @click="handleMore(1)">了解更多<img src="../assets/images/more.png" alt="" /></span>
          </div>
          <div class="nodeList">
            <div v-if="pxtzList.length > 0">
              <div class="li" v-for="q in pxtzList" :key="q.id" @click="handleNotedetail(q)">
                <span class="text_3"> {{ q.title }}</span
                ><span class="text_4">{{ q.publishtime }}</span>
              </div>
            </div>
            <div v-else style="font-size: 16px">暂无数据</div>
          </div>
        </div>
        <div class="note_right">
          <div class="note_title">
            <span class="title_1" style="color: #333">公告资讯</span
            ><span class="title_2" @click="handleMore(2)">了解更多<img src="../assets/images/more.png" alt="" /></span>
          </div>
          <div class="nodeList">
            <div v-if="xwzxList.length > 0">
              <div class="li" v-for="w in xwzxList" :key="w.id" @click="handleNotedetail(w)">
                <span class="text_3">{{ w.title }}</span
                ><span class="text_4">{{ w.publishtime }}</span>
              </div>
            </div>
            <div v-else style="font-size: 16px">暂无数据</div>
          </div>
        </div>
      </div>
      <!-- 快捷报名 -->
      <div class="group_4" v-if="codeList.length > 0">
        <div class="courseList" v-for="item in codeList" :key="item.id">
          <div class="courseTitle">
            <div>
              <span class="text_5">{{ item.codeName }}</span>
              <!-- <span class="text_6">提供全流程、专业化的培训服务，助力学员快速拿证、安全上岗</span> -->
            </div>
            <div class="moreCourse" @click="handleCode">更多专业<img src="../assets/images/more.png" alt="" /></div>
          </div>
          <div style="display: flex" v-if="item.children != null && item.children.length > 0">
            <div class="courseContent" v-for="value in item.children.slice(0, 6)" :key="value.id" @click="handleRegistration(value)">
              <div class="courseBox">
                <div class="cover">
                  <img :src="value.codeDesc" alt="" v-if="value.codeDesc != null && value.codeDesc != ''" />
                  <img src="../assets/images/noImg.jpg" alt="" v-else />
                </div>
                <div class="info">
                  <div class="text_7">{{ value.codeName }}</div>
                  <div class="text_8">
                    <span class="registration" >立即报名</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 查询服务 -->
    <div class="group_5">
      <div class="text_9">查询服务</div>
      <div style="display: flex; margin-top: 21px; justify-content: space-between; width: 1130px">
        <div class="box_left">
          <img src="../assets/images/Group 1663@2x.png" alt="" />
          <div class="search" @click="handleSearch(1)">立即查询</div>
        </div>
        <div class="box_right">
          <img src="../assets/images/Group 1664@2x.png" alt="" />
          <div class="search" @click="handleSearch(2)">立即查询</div>
        </div>
      </div>
      <div class="text_10">注册和查询过程中，务必准确填写个人信息，若遇到问题，可拨打官方客服电话寻求帮助。​</div>
    </div>
    <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; background-color: #fff">
      <!-- 平台优势 -->
      <div class="group_6">
        <div class="texte_11">平台优势</div>
        <div class="texte_12">
          凭借数字化特性，打破时空限制实现广覆盖与低成本，通过定制化内容、沉浸式实操体验及智能化管理考核，高效提升组织应急培训的针对性、实效性与合规性。
        </div>
        <div class="ysBox">
          <div class="ysList">
            <div class="ysimg">
              <img src="../assets/images/Group 1666@2x.png" alt="" />
            </div>
            <div class="text_13">数字化平台</div>
            <div class="text_14">新一代It技术、大数据、人工智能和云计算技术，实现经营管理数智化平台；</div>
          </div>
          <div class="ysList">
            <div class="ysimg">
              <img src="../assets/images/Group 1671@2x.png" alt="" />
            </div>
            <div class="text_13">安全培训saas平台</div>
            <div class="text_14">
              赋能全国各类安全与应急教育培训机构，在线培训SaaS平台，确保用户安全稳定使用，实现安全生产培训全流程需求；
            </div>
          </div>
          <div class="ysList">
            <div class="ysimg">
              <img src="../assets/images/Group 1672@2x.png" alt="" />
            </div>
            <div class="text_13">多元化学习</div>
            <div class="text_14">多种学习模式混合部署，随时随地轻松搭建培训项目。完善的防作弊机制，杜绝挂课替代学习等行为发生；</div>
          </div>
          <div class="ysList">
            <div class="ysimg">
              <img src="../assets/images/Group 1673@2x.png" alt="" />
            </div>
            <div class="text_13">多端同源</div>
            <div class="text_14">多端同源，一触即达，并支持电脑端、移动端、微信端等多端登录学习及题库练习；</div>
          </div>
          <div class="ysList">
            <div class="ysimg">
              <img src="../assets/images/Group 1674@2x.png" alt="" />
            </div>
            <div class="text_13">系统化配置</div>
            <div class="text_14">满足机构在三岗、全员、专题专项等相关安全培训，适用于矿山、危化等八大应急部门主管行业培训需求；</div>
          </div>
        </div>
      </div>
      <!-- 名师专栏 -->
      <div class="group_7">
        <div class="texte_11">名师专栏</div>
        <div class="texte_12">
          各位名师将以理论结合实操的授课方式，把前沿政策、专业知识与典型案例深度融合，为学员打造兼具权威性、实用性与针对性的精品课程，助力快速提升应急管理综合素养与实战处置能力。
        </div>
        <div class="tearchBox">
          <div v-if="teacherList.length > 0" style="display: flex">
            <div class="tearchList" v-for="t in teacherList" :key="t.id" @click="tearchDetail(t.id)">
              <div style="display: flex">
                <div class="avater">
                  <img :src="t.photo" alt="" v-if="t.photo != '' && t.photo != null" />
                  <img src="../assets/images/avater.png" alt="" v-else />
                </div>
                <div style="margin-left: 10px">
                  <div class="text_15">{{ t.realname }}</div>
                  <div class="text_16">{{ t.position }}</div>
                </div>
              </div>
              <div class="tearchInfo">
                {{ t.memo }}
              </div>
            </div>
          </div>

          <div class="text_17" v-else style="text-align: center">暂无数据</div>
        </div>
        <div class="tearchBtn">
          <div class="btn_1" @click="handleTearch">更多名师</div>
        </div>
      </div>
      <!-- 应急科普 -->
      <div class="group_8">
        <div class="texte_11">应急科普</div>
        <div class="texte_12">
          快速掌握实用应急技能，强化风险防范意识，从源头降低灾害损失，助力构建 “人人懂应急、会应急” 的安全防护体系。
        </div>
        <div class="yjBox">
          <div class="yjList" @click="handleMore(3)">
            <div class="text_18">应急指南</div>
            <div class="text_19">清晰明确的指出应急处置的关键节点、操作要点及注意事项</div>
          </div>
          <div class="yjList" @click="handleMore(4)">
            <div class="text_18">生活安全</div>
            <div class="text_19">实用的防范技巧与典型案例警示，帮助用户提升安全防范意识</div>
          </div>
          <div class="yjList" @click="handleMore(5)">
            <div class="text_18">自然灾害</div>
            <div class="text_19">统梳理灾害的成因特点、预警信号、避险逃生技巧及灾后自救互救方法</div>
          </div>
          <div class="yjList" @click="handleMore(6)">
            <div class="text_18">事故灾害</div>
            <div class="text_19">解析事故成因、特性及典型案例，应急处置流程与自救互救技巧</div>
          </div>
        </div>
      </div>
    </div>
    <pcBottom></pcBottom>
  </div>
</template>
<script>
import pcHeaders from './component/head.vue';
import pcBottom from './component/bottom.vue';
import doubao from '@/views/component/doubao.vue';
import { getList, codeListBySpotId } from '../api/index';

// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    pcHeaders,
    pcBottom,
    doubao

  },
  metaInfo() {
    return {
      title: this.title + '-安全生产学习平台',
      meta: [
        {
          charset: 'utf-8'
        },
        {
          name: 'viewport',
          content: 'width=device-width, initial-scale=1.0,minimum-scale=1.0, maximum-scale=1.0, user-scalable=no'
        }
      ]
    };
  },
  data() {
    // 这里存放数据
    return {
      knowledgeBaseId: 'your-knowledge-base-id',

      lunboPicList: [], //轮播图
      kstdCodeList: [],
      allCodeList: [],
      mobile_url: '', //移动端地址
      xwzxList: [], //新闻资讯
      pxtzList: [], //培训通知
      logoList: '', //logo
      teacherList: [],
      codeList: [] //分类列表
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
     // 监听消息发送成功
    handleMessageSuccess(data) {
      console.log('问答成功：', data);
      // 可在此记录日志、统计等
    },
    // 监听消息发送失败
    handleMessageError(msg) {
      console.error('问答失败：', msg);
      this.$message?.error(msg);
    },
    //去专业页面
    handleCode() {
      this.$router.push({
        path: '/courseSelection'
      });
    },
    //获取分类数据
    getCode() {
      codeListBySpotId().then(res => {
        console.log(res, '999');

        this.codeList = res.data.data.slice(0, 3);
      });
    },
    //去资讯页
    handleMore(item) {
      console.log(item, '2233');

      if (item == 1) {
        this.$router.push({
          path: '/tzgg'
        });
      } else if (item == 2) {
        this.$router.push({
          path: '/tzgg',
          query: {
            type: '2'
          }
        });
      } else if (item == 3) {
        this.$router.push({
          path: '/tzgg',
          query: {
            type: '3'
          }
        });
      } else if (item == 4) {
        this.$router.push({
          path: '/tzgg',
          query: {
            type: '4'
          }
        });
      } else if (item == 5) {
        this.$router.push({
          path: '/tzgg',
          query: {
            type: '5'
          }
        });
      } else if (item == 6) {
        this.$router.push({
          path: '/tzgg',
          query: {
            type: '6'
          }
        });
      }
    },
    //立即查询
    handleSearch(item) {
      if (item == 1) {
        window.open('https://cx.mem.gov.cn/', '_blank');
      } else {
        window.open('https://cx.mem.gov.cn/safety?index=1', '_blank');
      }
    },
    //去培训通知详情页
    handleNotedetail(q) {
      this.$router.push({
        path: '/tzgg',
        query: {
          id: q.id
        }
      });
    },
    //快捷通道
    handleCode1(item) {
      this.$router.push({
        path: '/courseSelection',
        query: {
          type: item
        }
      });
    },
    //去专业页面
    handleCode() {
      this.$router.push({
        path: '/courseSelection'
      });
    },
    //获取分类数据
    getCode() {
      codeListBySpotId().then(res => {
        console.log(res, '999');

        this.codeList = res.data.data;
      });
    },
    //去资讯页
    // handleMore(item) {
    //   if (item == 1) {
    //     this.$router.push({
    //       path: '/tzgg'
    //     });
    //   } else {
    //     this.$router.push({
    //       path: '/tzgg',
    //       query: {
    //         type: '2'
    //       }
    //     });
    //   }
    // },
    //立即查询
    handleSearch(item) {
      if (item == 1) {
        window.open('https://cx.mem.gov.cn/', '_blank');
      } else {
        window.open('https://cx.mem.gov.cn/safety?index=1', '_blank');
      }
    },
    //去培训通知详情页
    handleNotedetail(q) {
      this.$router.push({
        path: '/tzgg',
        query: {
          id: q.id
        }
      });
    },
    //快捷通道
    handleCode1(item) {
      this.$router.push({
        path: '/courseSelection',
        query: {
          type: item
        }
      });
    },
    //去报名学习页
    handleRegistration(value) {
      this.$router.push({
        path: '/submit',
        query: {
          id: value.cid,
          codeName: value.codeName,
          trainIndustry: value.trainIndustry,
          parentId: value.parentId,
        }
      });
    },
    getList() {
      getList().then(res => {
        if (res.data.data.mobile_url != '' && res.data.data.mobile_url != null) {
          //       window.scrollTo({
          //   top: 0,
          //   behavior: 'smooth'
          // });
          this.mobile_url = res.data.data.mobile_url;
          const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
          console.log(isMobile);
          if (isMobile) {
            window.location.href = this.mobile_url;
          }
        }
        this.lunboPicList = res.data.data.pictureList; //轮播图
        this.xwzxList = res.data.data.xwzxList; //新闻资讯
        this.pxtzList = res.data.data.pxtzList; //培训通知
        // this.logoList = res.data.data.logoList[0].picUrl;
        this.teacherList = res.data.data.teacherList;
      });
    },
    handleTearch() {
      this.$router.push({
        path: '/tearchList'
      });
    },
    tearchDetail(id) {
      this.$router.push({
        path: '/tearchDetail',
        query: {
          id: id
        }
      });
    },

    //条轮播详情
    swipeDetail(item) {
      if (item.jumpway == '02') {
        if (item.picDesc.startsWith('http')) {
          window.location.href = item.picDesc; // 直接跳转到该地址
        } else {
          this.$router.push({
            path: '/message',
            query: {
              id: item.id,
              index: 1
            }
          });
        }
      } else if (item.jumpway == '01') {
        this.$router.push({
          path: '/message',
          query: {
            id: item.id,
            index: 1
          }
        });
      }
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getList();
    this.getCode();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.chat-page {
  padding: 30px;
  max-width: 600px;
  margin: 0 auto;
}

.chat-actions {
  margin-top: 20px;
  display: flex;
  gap: 10px;
}

.chat-actions button {
  padding: 8px 16px;
  border: 1px solid #4299e1;
  background-color: white;
  color: #4299e1;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
}

.chat-actions button:hover {
  background-color: #4299e1;
  color: white;
}
.nav {
  position: relative;
  // margin-bottom: 20px;
}

::v-deep {
  .el-carousel__container {
    width: 100% !important;
    height: 450px;

    img {
      width: 100%;
      height: 450px;
    }
  }

  .el-carousel__indicators--outside {
    position: absolute;
    left: 50%;
    bottom: 72px !important;
  }

  .el-carousel__arrow {
    // display: none !important;
  }

  .is-active {
    .el-carousel__button {
      width: 28px;
      height: 4px;
      background: #3172f6 !important;
    }
  }

  .el-carousel__button {
    width: 28px;
    height: 4px;
    background: #d9d9d9;
  }
}

.flowBox {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 72px;
  background: rgba(49, 114, 246, 0.16);
  position: absolute;
  // bottom: 0;
  top: 378px;
  z-index: 10;

  .group_1 {
    width: 1400px;
    display: flex;
    align-items: center;
  }

  .flow_1 {
    margin-left: 34px;
    display: flex;

    img {
      width: 40px;
      height: 40px;
    }
  }

  .flow_2 {
    margin-left: 10px;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: 500;
    font-size: 14px;
    color: #666666;
  }

  .jiantou {
    margin-left: 34px;

    img {
      width: 28px;
      height: 28px;
    }
  }
}

.group_2 {
  width: 1400px;
  margin-top: 40px;
  margin-bottom: 50px;
  display: flex;
  justify-content: space-between;

  .kjBox {
    background-image: url('../assets/images/Group 1625@2x.png');
    background-size: cover;
    width: 320px;
    height: 130px;
    padding: 30px 30px 27px 30px;
    cursor: pointer;
  }

  .kjBox_1 {
    background-image: url('../assets/images/Group 1626@2x.png');
    background-size: cover;
    width: 320px;
    height: 130px;
    padding: 30px 30px 27px 30px;
    cursor: pointer;
  }

  .kjBox_2 {
    background-image: url('../assets/images/Group 1627@2x.png');
    background-size: cover;
    width: 320px;
    height: 130px;
    padding: 30px 30px 27px 30px;
    cursor: pointer;
  }

  .kjBox_3 {
    background-image: url('../assets/images/Group 1628@2x.png');
    background-size: cover;
    width: 320px;
    height: 130px;
    cursor: pointer;

    padding: 30px 30px 27px 30px;
  }

  .text_1 {
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: bold;
    font-size: 20px;
    color: #ffffff;
  }

  .text_2 {
    margin-top: 8px;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
  }
}

.group_3 {
  width: 1400px;
  height: auto;
  background: #f4f6fa;
  border-radius: 0px 0px 0px 0px;
  padding: 32px 30px;
  margin-bottom: 76px;
  display: flex;
  flex-wrap: nowrap;
  .note_right {
    padding-left: 70px;

    width: 670px;

    // align-items: flex-end;
  }
  .note_title {
    width: 600px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 20px;
  }
  .nodeList {
    width: 670px;

    .li {
      cursor: pointer;

      display: flex;
      margin-bottom: 18px;
      justify-content: space-between;
      width: 600px;
      .text_3 {
        width: 435px;
        display: inline-block;
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
        font-weight: 400;
        font-size: 16px;
        color: #222222;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .text_4 {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #88888a;
      }
    }
  }
  .note_left {
    border-right: 1px solid rgba(0, 0, 0, 0.1);
    // border-right: 1px solid rgba(0, 0, 0, 0.1);
  }
  .title_1 {
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: bold;
    font-size: 20px;
    color: #3172f6;
  }

  .title_2 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #666666;
    cursor: pointer;

    img {
      width: 12px;
      height: 12px;
    }
  }
}
.group_4 {
  width: 1400px;
  // margin-top: 76px;
  .courseList {
    margin-bottom: 60px;
    .courseTitle {
      height: 43px;
      border-bottom: 1px solid rgba(51, 51, 51, 0.1);
      display: flex;
      justify-content: space-between;
      .text_5 {
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
        font-weight: bold;
        font-size: 20px;
        color: #333333;
      }
      .text_6 {
        margin-left: 10px;
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
        font-weight: 400;
        font-size: 14px;
        color: #999999;
      }
      .moreCourse {
        cursor: pointer;

        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #666666;
        img {
          width: 12px;
          height: 12px;
        }
      }
    }
  }
  .courseContent {
    margin-top: 24px;
    margin-right: 16px;
  }
  .courseBox {
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.06);
        cursor: pointer;
    border-radius: 10px 10px 10px 10px;
    width: 220px;
    height: 186px;
    background: #f4f6fa;
    border-radius: 10px 10px;
    position: relative;

    .cover {
      border-radius: 10px;
      width: 220px;
      height: 176px;
    }
    .cover img {
      border-radius: 10px;
      width: 220px;
      height: 176px;
    }
    .info {
      background-color: #fff;
      position: absolute;
      bottom: 0px;
      left: 0;
      right: 0;
      width: 220px;
      padding: 8px 10px;
      border-radius: 0px 0px 10px 10px;

      height: 80px;
      .text_7 {
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #000000;
      }
      .text_8 {
        margin-top: 10px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
      }
      .registration {
        cursor: pointer;

        display: flex;
        align-items: center;
        justify-content: center;
        width: 88px;
        height: 32px;
        background: rgba(49, 114, 246, 0.1);
        border-radius: 16px 16px 16px 16px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #3172f6;
      }
    }
  }
}
.group_5 {
  padding: 30px 0px 26px 0px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 400px;
  background-image: url('../assets/images/Group 1991@2x.png');
  background-size: cover;
  .text_9 {
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: bold;
    font-size: 24px;
    color: #ffffff;
    text-align: center;
  }
  .box_left {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    // margin-right: 370px;
    img {
      width: 330px;
      height: 190px;
    }
  }
  .box_right {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      width: 330px;
      height: 190px;
    }
  }
  .search {
    margin-top: 20px;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: 400;
    font-size: 14px;
    color: #3172f6;
    text-align: center;
    line-height: 36px;
    width: 112px;
    cursor: pointer;
    height: 36px;
    background: #ffffff;
    border-radius: 20px 20px 20px 20px;
  }
  .text_10 {
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    text-align: center;
    margin-top: 25px;
  }
}
.group_6 {
  width: 1400px;
  margin-top: 80px;

  .ysBox {
    margin-top: 44px;
    display: flex;
    justify-content: space-between;
    .ysList {
      width: 260px;
      display: flex;
      align-items: center;
      flex-direction: column;
      padding: 30px 20px;
      height: 270px;
      background: #f4f6fa;
      border-radius: 0px 0px 0px 0px;
    }
    .ysimg img {
      width: 147px;
      height: 83px;
    }
    .text_13 {
      margin-top: 20px;
      font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
      font-weight: 500;
      font-size: 18px;
      color: #333333;
    }
    .text_14 {
      margin-top: 8px;
      font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
    }
  }
}
.texte_11 {
  text-align: center;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: bold;
  font-size: 24px;
  color: #333333;
}
.texte_12 {
  margin-top: 10px;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  text-align: center;
}
.group_7 {
  margin-top: 80px;
  background-image: url('../assets/images/Mask group@2x.png');
  width: 1400px;
  height: 480px;
  padding-top: 32px;
  .tearchBtn {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 30px;
    .btn_1 {
      cursor: pointer;
      width: 150px;
      height: 40px;
      border-radius: 20px 20px 20px 20px;
      border: 1px solid #3172f6;
      font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
      font-weight: 400;
      font-size: 14px;
      color: #3172f6;
      text-align: center;
      line-height: 40px;
    }
  }
  .tearchBox {
    // display: flex;
    margin-top: 47px;
    // justify-content: center;
  }
  .tearchList:nth-child(6) {
    margin-right: 0px;
  }
  .tearchList:nth-child(1) {
    margin-left: 45px;
  }
  .tearchList {
    cursor: pointer;

    margin-right: 21px;
    padding: 24px 20px;
    width: 200px;
    height: 240px;
    background: linear-gradient(180deg, #ffffff 0%, #ffffff 100%);
    box-shadow: 0px 5px 40px 0px rgba(65, 147, 246, 0.1);
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #ffffff;
    img {
      width: 48px;
      height: 48px;
      border-radius: 50%;
    }
    .text_15 {
      font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100px;
    }
    .text_16 {
      width: 100px;
      font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
      font-weight: 400;
      font-size: 12px;
      color: #999897;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .tearchInfo {
      margin-top: 10px;
      width: 160px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 7;
      overflow: hidden;
      line-height: 1.5; 
      /* 不要设置 height，让容器由 line-clamp 自动控制高度 */
      max-height: calc(1.5em * 7); 
      font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
      font-weight: 400;
      font-size: 12px;
      color: #333333;
    }
  }
}
.text_17 {
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
}
.group_8 {
  margin-bottom: 181px;
  width: 1400px;
  margin-top: 80px;
  .yjBox {
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }
  .yjList:nth-child(2) {
    background-size: cover;
    background-image: url('../assets/images/Group 1687@2x.png');
  }
  .yjList:nth-child(3) {
    background-size: cover;
    background-image: url('../assets/images/Group 1690@2x.png');
  }
  .yjList:nth-child(4) {
    background-size: cover;
    background-image: url('../assets/images/Group 1691@2x.png');
  }

  .yjList {
    cursor: pointer;

    padding: 35px 18px;
    width: 320px;
    height: 150px;
    background-size: cover;
    background-image: url('../assets/images/Mask group@2x (1).png');
    .text_18 {
      font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
      font-weight: bold;
      font-size: 20px;
      color: #ffffff;
    }
    .text_19 {
      width: 150px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #ffffff;
      margin-top: 4px;
    }
  }
}
</style>
